<template>
    <div id="step-type" class="step">
        <div class="col-12">
            <div id="flat" class="radio-check" v-on:click="setType('flat')">
                <div class="image">
                    <img :src="assetsUrl + '/flat.png'">
                </div>
                <div class="text">
                    Byt
                </div>
                <input type="radio" name="property_type" required value="flat" v-model="property">
            </div>

            <div id="house" class="radio-check" v-on:click="setType('house')">
                <div class="image">
                    <img :src="assetsUrl + '/house.png'">
                </div>
                <div class="text">
                    Rodinný dům
                </div>
                <input type="radio" name="property_type" required value="house" v-model="property">
            </div>

            <div id="cottage" class="radio-check" v-on:click="setType('cottage')">
                <div class="image">
                    <img :src="assetsUrl + '/cottage.png'">
                </div>
                <div class="text">
                    Chata/Chalupa
                </div>
                <input type="radio" name="property_type" required value="cottage" v-model="property">
            </div>

            <div id="land" class="radio-check" v-on:click="displayModal()">
                <div class="image">
                    <img :src="assetsUrl + '/land.png'">
                </div>
                <div class="text">
                    Pozemek
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Type",

        props: ['assetsUrl'],

        data: function() {
            return {
                property: null
            }
        },

        mounted: function () {
            $('#step-type .radio-check').on('click', function () {
                $('#step-type .radio-check').removeClass('active');
                $(this).addClass('active');
                $(this).find('input').prop('checked', true);
            });
        },

        computed: {
            required: function () {
                return this.property != null;
            }
        },

        methods: {
            getType: function () {
                return $('#step-type .radio-check input:checked').val();
            },

            setType: function (type) {
                $('#step-type .radio-check').removeClass('active');
                $('#' + type).addClass('active');
                this.property = type;
                this.$parent.setType(type);
            },

            displayModal: function () {
                setTimeout(function () {
                    $('#step-type .radio-check').removeClass('active');
                }, 100);

                $('#contact-form').modal({show: true});
            }
        }
    }
</script>

<style scoped>
    input[type="radio"] {
        display: none;
    }

    .radio-check {
        cursor: pointer;
    }
</style>
